import { Box, Button } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";
import AddIcon from "@mui/icons-material/Add";
import { useCallback } from "react";

type Props = {
  logo?: string | null;
  onLogoChange?: (logo: string) => void;
};

const Container = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  img {
    max-width: 220px;
    max-height: 72px;
    object-fit: contain;
  }

  ${(p) => p.theme.media.mobileDown} {
    img {
      max-width: 128px;
      max-height: 56px;
    }
  }
`;

export const SingleLogoEditor = (props: Props) => {
  const { logo, onLogoChange } = props;

  const handleLogoChange = useCallback(() => {
    if (onLogoChange) {
      alert("NOT IMPLEMENTED: Logo upload functionality");
    }
  }, [onLogoChange]);

  // TODO: Implement branding logo upload functionality
  if (!logo && !onLogoChange) return null;

  return (
    <Container>
      {logo && <img src={logo} alt="Logo" />}
      {!logo && onLogoChange && (
        <Button
          onClick={() => handleLogoChange()}
          startIcon={<AddIcon />}
          variant="outlined"
          size="small"
        >
          Add Brokerage Logo
        </Button>
      )}
    </Container>
  );
};
